<input
  #fileUpload
  hidden
  type="file"
  accept="image/*"
  (change)="uploadImage(fileUpload.files)"
/>

<div
  [style.display]="windowWidth > minMainMenuWidth ? 'block' : 'none'"
  class="menu-bar-container"
>
  <button id="fileMenu" mat-button [matMenuTriggerFor]="menuFile" #fileMenuTrigger="matMenuTrigger" (mouseenter)="onMenuMouseEnter(fileMenuTrigger)" (menuOpened)="onMenuOpened()">
    {{ httpService.getTransation().File }}
  </button>
  <button mat-button [matMenuTriggerFor]="menuEdit" #editMenuTrigger="matMenuTrigger" (mouseenter)="onMenuMouseEnter(editMenuTrigger)" (menuOpened)="onMenuOpened()">
    {{ httpService.getTransation().Edit }}
  </button>
  <button mat-button [matMenuTriggerFor]="menuView" #viewMenuTrigger="matMenuTrigger" (mouseenter)="onMenuMouseEnter(viewMenuTrigger)" (menuOpened)="onMenuOpened()">
    {{ httpService.getTransation().View }}
  </button>
  <button id="imageMenu" mat-button [matMenuTriggerFor]="menuImage" #imageMenuTrigger="matMenuTrigger" (mouseenter)="onMenuMouseEnter(imageMenuTrigger)" (menuOpened)="onMenuOpened()">
    {{ httpService.getTransation().Image }}
  </button>
  <button mat-button [matMenuTriggerFor]="menuPattern" #patternMenuTrigger="matMenuTrigger" (mouseenter)="onMenuMouseEnter(patternMenuTrigger)" (menuOpened)="onMenuOpened()">
    {{ httpService.getTransation().Pattern }}
  </button>
  <button
    id="toolsMenu"
    mat-button
    [matMenuTriggerFor]="menuTools"
    #toolsMenuTrigger="matMenuTrigger"
    (mouseenter)="onMenuMouseEnter(toolsMenuTrigger)"
    (menuOpened)="onMenuOpened()"
    *ngIf="windowWidth >= 750 && windowHeight >= 650"
  >
    {{ httpService.getTransation().Tools }}
  </button>
  <button mat-button [matMenuTriggerFor]="menuHelp" #helpMenuTrigger="matMenuTrigger" (mouseenter)="onMenuMouseEnter(helpMenuTrigger)" (menuOpened)="onMenuOpened()">
    {{ httpService.getTransation().Help }}
  </button>
</div>

<div
  #profileContainer
  class="profile-container"
  [style.height]="windowWidth > minMainMenuWidth ? '63px' : '43px'"
  [style.paddingTop]="windowWidth > minMainMenuWidth ? '16px' : '0px'"
>
  <button
    mat-icon-button
    [matMenuTriggerFor]="menuProfile"
    class="profile-button"
    (menuOpened)="onProfileMenuOpened()"
    (menuClosed)="onProfileMenuClosed()"
  >
    <img
      [src]="getPhotoUrl()"
      [matTooltip]="getFullname()"
      referrerpolicy="no-referrer"
      style="width: 40px; height: 40px; border-radius: 50%"
    />
  </button>
  <mat-menu #menuProfile="matMenu" class="profile-menu-improved">
    <div class="profile-menu-container">
      <!-- Header Section -->
      <div class="profile-menu-header">
        <img
          [src]="getPhotoUrl()"
          [matTooltip]="getFullname()"
          class="profile-menu-avatar"
        />
        <div class="profile-menu-name">{{ getFullname() }}</div>
        <div class="profile-menu-version">{{ httpService.getTransation().AppName }} {{ httpService.VERSION }}</div>
      </div>

      <!-- Subscription Status Section -->
      <div class="profile-menu-section">
        <div class="profile-section-label">{{ httpService.getTransation().YourPlan }}</div>

        <!-- FREE PLAN -->
        <div *ngIf="isUserFree" class="subscription-status-card free-plan">
          <div class="subscription-status-header">
            <div class="subscription-status-name">
              <mat-icon class="subscription-icon">stars</mat-icon>
              <span>{{ httpService.getTransation().FreePlan }}</span>
            </div>
            <div class="subscription-status-badge free-badge">{{ httpService.getTransation().Active }}</div>
          </div>

          <div class="subscription-usage">
            <div class="usage-label">{{ httpService.getTransation().PatternUsage }}</div>
            <div class="usage-stats">{{ userPatternCount }} {{ httpService.getTransation().PatternsUsed.replace('{0}', '') }}</div>
            <div class="usage-bar">
              <div
                class="usage-bar-fill"
                [style.width.%]="usagePercentage"
                [ngClass]="{
                  'usage-critical': usagePercentage >= 100,
                  'usage-warning': usagePercentage >= 67 && usagePercentage < 100,
                  'usage-normal': usagePercentage < 67
                }">
              </div>
            </div>
            <div class="usage-remaining" *ngIf="remainingFreePatterns > 0">
              {{ remainingFreePatterns }} {{ httpService.getTransation().PatternRemaining.replace('{0}', '').replace('{1}', remainingFreePatterns !== 1 ? 's' : '') }}
            </div>
            <div class="usage-limit-reached" *ngIf="remainingFreePatterns === 0">
              <mat-icon class="limit-icon">warning</mat-icon>
              <span>{{ httpService.getTransation().LimitReached }}</span>
            </div>
          </div>

          <!-- Clear Free Plan Limitations -->
          <div class="plan-limitations">
            <div class="limitation-item">
              <mat-icon class="limitation-icon">info</mat-icon>
              <span class="limitation-text">{{ httpService.getTransation().FreePlanLimited }}</span>
            </div>
          </div>

          <button
            mat-raised-button
            color="primary"
            class="subscription-action-button upgrade-button"
            (click)="showSubscription()"
          >
            <mat-icon>upgrade</mat-icon>
            {{ httpService.getTransation().UpgradeToPro }}
          </button>

          <div class="plan-benefits-preview">
            ✓ Unlimited patterns • HD export • PDF print • Pattern reader
          </div>
        </div>

        <!-- PRO PLAN (Monthly/Yearly) -->
        <div *ngIf="!isUserFree" class="subscription-status-card pro-plan">
          <div class="subscription-status-header">
            <div class="subscription-status-name">
              <mat-icon class="subscription-icon pro-icon">workspace_premium</mat-icon>
              <span>{{ httpService.getTransation().ProPlan }}</span>
            </div>
            <div class="subscription-status-badge pro-badge">{{ httpService.getTransation().Active }}</div>
          </div>

          <div class="subscription-features">
            <div class="feature-item">
              <mat-icon class="feature-check">check_circle</mat-icon>
              <span>{{ httpService.getTransation().UnlimitedPatternsFeature }}</span>
            </div>
            <div class="feature-item">
              <mat-icon class="feature-check">check_circle</mat-icon>
              <span>{{ httpService.getTransation().HDExportPrint }}</span>
            </div>
          </div>

          <button
            mat-stroked-button
            class="subscription-action-button manage-button"
            (click)="manageSubscription()"
          >
            <mat-icon>settings</mat-icon>
            {{ httpService.getTransation().ManageSubscription }}
          </button>

          <div class="manage-hint">
            {{ httpService.getTransation().ManageSubscriptionHint }}
          </div>
        </div>
      </div>

      <!-- Divider -->
      <div class="profile-menu-divider"></div>

      <!-- Account Actions Section -->
      <div class="profile-menu-section">
        <button
          mat-menu-item
          class="profile-menu-item"
          (click)="showProfile()"
        >
          <mat-icon>person</mat-icon>
          <span>{{ httpService.getTransation().ProfileSettings }}</span>
        </button>
        <button
          mat-menu-item
          class="profile-menu-item"
          (click)="toggleHelpPanel()"
        >
          <mat-icon>help_outline</mat-icon>
          <span>{{ httpService.getTransation().NeedHelpCta || 'Need help?' }}</span>
        </button>
        <button
          mat-menu-item
          class="profile-menu-item"
          (click)="signOut()"
        >
          <mat-icon>logout</mat-icon>
          <span>{{ httpService.getTransation().SignOut }}</span>
        </button>
      </div>
    </div>
  </mat-menu>
  <button
    mat-icon-button
    (click)="toggleRightSidebar()"
    class="toggle-right-sidebar"
  >
    <mat-icon>menu</mat-icon>
  </button>
</div>

<mat-toolbar style="padding-left: 8px; padding-right: 8px; max-width: calc(100vw - 100px); overflow: hidden;">
  <button
    #dotsMenu
    mat-icon-button
    [matMenuTriggerFor]="mainMenu"
    [style.display]="windowWidth <= minMainMenuWidth ? 'block' : 'none'"
    class="dots-menu-button"
  >
    <mat-icon>more_vert</mat-icon>
  </button>

  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().New"
    (click)="newPattern()"
    *ngIf="windowWidth >= minMediumToolbarWidth"
  >
    <mat-icon>insert_drive_file</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().Open"
    (click)="openPattern()"
    *ngIf="windowWidth >= minMediumToolbarWidth"
  >
    <mat-icon>folder_open</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().Save"
    (click)="savePattern()"
    [disabled]="!canSavePattern()"
    *ngIf="windowWidth >= minMediumToolbarWidth"
    [appOnboardingHint]="(onboardingService.saveReminderHint$ | async)?.message"
    [hintVisible]="(onboardingService.saveReminderHint$ | async)?.visible"
    [hintPosition]="'bottom'"
  >
    <mat-icon>save</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().SaveAs"
    (click)="saveAsPattern()"
    *ngIf="windowWidth >= minMediumToolbarWidth"
  >
    <mat-icon>save_alt</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().Print"
    (click)="printPattern()"
    *ngIf="windowWidth >= minMediumToolbarWidth"
  >
    <mat-icon>print</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().PatternReader"
    (click)="openPatternReader()"
    *ngIf="windowWidth >= minMediumToolbarWidth"
  >
    <mat-icon>record_voice_over</mat-icon>
  </button>
  <mat-divider [vertical]="true" class="style-fix"></mat-divider>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().Undo + ' ' + undoShortcut"
    (click)="undo()"
    [disabled]="!canUndo()"
  >
    <mat-icon>undo</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().Redo + ' ' + redoShortcut"
    (click)="redo()"
    [disabled]="!canRedo()"
  >
    <mat-icon>redo</mat-icon>
  </button>
  <mat-divider
    [vertical]="true"
    class="style-fix"
    *ngIf="windowWidth >= minMediumToolbarWidth"
  ></mat-divider>
  <button
    mat-icon-button
    matTooltip="Rows & Columns..."
    [matMenuTriggerFor]="rowsColsMenu"
    *ngIf="windowWidth >= minMediumToolbarWidth"
  >
    <mat-icon>grid_3x3</mat-icon>
  </button>
  <mat-divider
    [vertical]="true"
    class="style-fix"
  ></mat-divider>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().ZoomIn + ' ' + zoomInShortcut"
    (click)="zoomIn()"
    [disabled]="!canZoomIn()"
    *ngIf="windowWidth >= minSmallToolbarWidth"
  >
    <mat-icon>zoom_in</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().ZoomOut + ' ' + zoomOutShortcut"
    (click)="zoomOut()"
    [disabled]="!canZoomOut()"
    *ngIf="windowWidth >= minSmallToolbarWidth"
  >
    <mat-icon>zoom_out</mat-icon>
  </button>
  <!-- <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().ShowHideRealisticBeads"
    (click)="toggleRealisticBeadsEnabled()"
    [disabled]="!canShowRealisticBeads()"
    *ngIf="windowWidth >= minFullToolbarWidth"
  >
    <mat-icon>{{ iconNameRealisticBeadsVisibility }}</mat-icon>
  </button> -->
  <mat-divider
    [vertical]="true"
    class="style-fix"
    *ngIf="windowWidth >= minLargeToolbarWidth"
  ></mat-divider>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().InsertImageTooltip"
    (click)="fileUpload.click()"
    *ngIf="windowWidth >= minLargeToolbarWidth"
    [appOnboardingHint]="(onboardingService.uploadImageHint$ | async)?.message"
    [hintVisible]="(onboardingService.uploadImageHint$ | async)?.visible"
    [hintPosition]="'bottom'"
  >
    <mat-icon>photo_library</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().RotateImageLeft"
    (click)="rotateImageLeft()"
    [disabled]="!canRotateImage()"
    *ngIf="windowWidth >= minLargeToolbarWidth"
  >
    <mat-icon>crop_rotate</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().RotateImageRight"
    (click)="rotateImageRight()"
    [disabled]="!canRotateImage()"
    *ngIf="windowWidth >= minLargeToolbarWidth"
  >
    <mat-icon class="flip-x">crop_rotate</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().ShowHideImage"
    (click)="toggleImageVisibility()"
    [disabled]="!canToggleImageVisibility()"
    *ngIf="windowWidth >= minLargeToolbarWidth"
  >
    <mat-icon>{{ iconNameImageVisibility }}</mat-icon>
  </button>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().TransferImage"
    (click)="transferImage()"
    [disabled]="!canTransferImage()"
    *ngIf="windowWidth >= minLargeToolbarWidth"
    [appOnboardingHint]="(onboardingService.transferImageHint$ | async)?.message"
    [hintVisible]="(onboardingService.transferImageHint$ | async)?.visible"
    [hintPosition]="'bottom'"
  >
    <mat-icon>flash_on</mat-icon>
  </button>
  <mat-divider
    [vertical]="true"
    class="style-fix"
    *ngIf="windowWidth >= minFullToolbarWidth"
  ></mat-divider>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().TransformPattern"
    (click)="showTransformPattern()"
    *ngIf="windowWidth >= minFullToolbarWidth"
  >
    <mat-icon>transform</mat-icon>
  </button>
  <button
    mat-icon-button
    (click)="toggleRotatedPattern()"
    [matTooltip]="currentRotatedPatternTooltip"
    *ngIf="windowWidth >= minFullToolbarWidth"
  >
    <mat-icon [ngClass]="{ 'rotated-90': isRotatedPattern }"
      >line_weight</mat-icon
    >
  </button>
  <mat-divider
    [vertical]="true"
    class="style-fix"
    *ngIf="windowWidth >= minFullToolbarWidth"
  ></mat-divider>
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().PaletteEditor"
    (click)="showPaletteEditor()"
    *ngIf="
      windowWidth >= minFullToolbarWidth &&
      windowWidth >= 750 &&
      windowHeight >= 650
    "
  >
    <mat-icon>list_alt</mat-icon>
  </button>
  <mat-divider
    [vertical]="true"
    class="style-fix"
    *ngIf="windowWidth >= minFullToolbarWidth"
  ></mat-divider>
  <!-- Welcome tour button removed - replaced with new onboarding system -->
  <button
    mat-icon-button
    [matTooltip]="httpService.getTransation().VideoTutorial"
    (click)="videoTutorial()"
    *ngIf="windowWidth >= minFullToolbarWidth"
  >
    <mat-icon>movie</mat-icon>
  </button>
</mat-toolbar>

<mat-menu #mainMenu="matMenu" hasBackdrop="true">
  <button mat-menu-item [matMenuTriggerFor]="menuFile" #mobileFileMenuTrigger="matMenuTrigger">
    {{ httpService.getTransation().File }}
  </button>
  <button mat-menu-item [matMenuTriggerFor]="menuEdit" #mobileEditMenuTrigger="matMenuTrigger">
    {{ httpService.getTransation().Edit }}
  </button>
  <button mat-menu-item [matMenuTriggerFor]="menuView" #mobileViewMenuTrigger="matMenuTrigger">
    {{ httpService.getTransation().View }}
  </button>
  <button mat-menu-item [matMenuTriggerFor]="menuImage" #mobileImageMenuTrigger="matMenuTrigger">
    {{ httpService.getTransation().Image }}
  </button>
  <button mat-menu-item [matMenuTriggerFor]="menuPattern" #mobilePatternMenuTrigger="matMenuTrigger">
    {{ httpService.getTransation().Pattern }}
  </button>
  <button
    mat-menu-item
    [matMenuTriggerFor]="menuTools"
    *ngIf="windowWidth >= 750 && windowHeight >= 650"
  >
    {{ httpService.getTransation().Tools }}
  </button>
  <button mat-menu-item [matMenuTriggerFor]="menuHelp">
    {{ httpService.getTransation().Help }}
  </button>
</mat-menu>

<mat-menu #menuFile="matMenu" hasBackdrop="false" (closed)="onMenuClosed(); clearHighlight()" (opened)="onMenuOpened()">
  <button mat-menu-item (click)="newPattern()">
    <mat-icon>insert_drive_file</mat-icon>
    {{ httpService.getTransation().New }}
  </button>
  <button mat-menu-item (click)="openPattern()">
    <mat-icon>folder_open</mat-icon>
    {{ httpService.getTransation().Open }}
  </button>
  <button mat-menu-item (click)="savePattern()" [disabled]="!canSavePattern()" [class.highlighted-menu-item]="isMenuItemHighlighted('save')">
    <mat-icon>save</mat-icon>
    {{ httpService.getTransation().Save }}
  </button>
  <button mat-menu-item (click)="saveAsPattern()">
    <mat-icon>save_alt</mat-icon>
    {{ httpService.getTransation().SaveAs }}
  </button>
  <button mat-menu-item (click)="printPattern()">
    <mat-icon>print</mat-icon>
    {{ httpService.getTransation().Print }}
  </button>
  <button mat-menu-item (click)="openPatternReader()">
    <mat-icon>record_voice_over</mat-icon>
    {{ httpService.getTransation().PatternReader }}
  </button>
</mat-menu>
<mat-menu #menuEdit="matMenu" hasBackdrop="false" (closed)="onMenuClosed()" (opened)="onMenuOpened()">
  <button mat-menu-item (click)="undo()" [disabled]="!canUndo()">
    <mat-icon>undo</mat-icon>
    {{ httpService.getTransation().Undo + " " + undoShortcut }}
  </button>
  <button mat-menu-item (click)="redo()" [disabled]="!canRedo()">
    <mat-icon>redo</mat-icon>
    {{ httpService.getTransation().Redo + " " + redoShortcut }}
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item [matMenuTriggerFor]="rowsColsMenu">
    <mat-icon>grid_3x3</mat-icon>
    Rows & Columns
  </button>
</mat-menu>
<mat-menu #rowsColsMenu="matMenu" hasBackdrop="false">
  <button mat-menu-item (click)="onInsertRows()">
    <mat-icon>add</mat-icon>
    Insert Rows...
  </button>
  <button mat-menu-item (click)="onInsertCols()">
    <mat-icon>add</mat-icon>
    Insert Columns...
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="onRemoveRows()">
    <mat-icon>remove</mat-icon>
    Remove Rows...
  </button>
  <button mat-menu-item (click)="onRemoveCols()">
    <mat-icon>remove</mat-icon>
    Remove Columns...
  </button>
</mat-menu>
<mat-menu #menuView="matMenu" hasBackdrop="false" (closed)="onMenuClosed()" (opened)="onMenuOpened()">
  <button mat-menu-item (click)="zoomIn()" [disabled]="!canZoomIn()">
    <mat-icon>zoom_in</mat-icon>
    {{ httpService.getTransation().ZoomIn + " " + zoomInShortcut }}
  </button>
  <button mat-menu-item (click)="zoomOut()" [disabled]="!canZoomOut()">
    <mat-icon>zoom_out</mat-icon>
    {{ httpService.getTransation().ZoomOut + " " + zoomOutShortcut }}
  </button>
  <!-- <button
    mat-menu-item
    (click)="toggleRealisticBeadsEnabled()"
    [disabled]="!canShowRealisticBeads()"
  >
    <mat-icon>{{ iconNameRealisticBeadsVisibility }}</mat-icon>
    {{ httpService.getTransation().ShowHideRealisticBeads }}
  </button> -->
</mat-menu>
<mat-menu #menuImage="matMenu" hasBackdrop="false" (closed)="onMenuClosed(); clearHighlight()" (opened)="onMenuOpened()">
  <button mat-menu-item (click)="fileUpload.click()" [class.highlighted-menu-item]="isMenuItemHighlighted('insert_image')">
    <mat-icon>photo_library</mat-icon>
    {{ httpService.getTransation().InsertImage }}
  </button>
  <button
    mat-menu-item
    (click)="rotateImageLeft()"
    [disabled]="!canRotateImage()"
  >
    <mat-icon>crop_rotate</mat-icon>
    {{ httpService.getTransation().RotateImageLeft }}
  </button>
  <button
    mat-menu-item
    (click)="rotateImageRight()"
    [disabled]="!canRotateImage()"
  >
    <mat-icon class="flip-x">crop_rotate</mat-icon>
    {{ httpService.getTransation().RotateImageRight }}
  </button>
  <button
    mat-menu-item
    (click)="toggleImageVisibility()"
    [disabled]="!canToggleImageVisibility()"
  >
    <mat-icon>{{ iconNameImageVisibility }}</mat-icon>
    {{ httpService.getTransation().ShowHideImage }}
  </button>
  <button
    mat-menu-item
    (click)="transferImage()"
    [disabled]="!canTransferImage()"
    [class.highlighted-menu-item]="isMenuItemHighlighted('transfer_image')"
  >
    <mat-icon>flash_on</mat-icon>
    {{ httpService.getTransation().TransferImage }}
  </button>
</mat-menu>
<mat-menu #menuPattern="matMenu" hasBackdrop="false" (closed)="onMenuClosed()" (opened)="onMenuOpened()">
  <button mat-menu-item (click)="showTransformPattern()">
    <mat-icon>transform</mat-icon>
    {{ httpService.getTransation().TransformPattern }}
  </button>
  <button mat-menu-item [matMenuTriggerFor]="menuRotatedPattern">
    <mat-icon [ngClass]="{ 'rotated-90': isRotatedPattern }"
      >line_weight</mat-icon
    >
    {{ getCurrentRotatedPatternTooltip() }}
  </button>
</mat-menu>
<mat-menu #menuRotatedPattern="matMenu" hasBackdrop="false">
  <button mat-menu-item (click)="setRotatedPattern(true)">
    <mat-icon class="rotated-90">line_weight</mat-icon>
    {{ httpService.getTransation().RotatedPatternOn }}
  </button>
  <button mat-menu-item (click)="setRotatedPattern(false)">
    <mat-icon>line_weight</mat-icon>
    {{ httpService.getTransation().RotatedPatternOff }}
  </button>
</mat-menu>
<mat-menu #menuTools="matMenu" hasBackdrop="false" (closed)="onMenuClosed()" (opened)="onMenuOpened()">
  <button mat-menu-item (click)="showPaletteEditor()">
    <mat-icon>list_alt</mat-icon>
    {{ httpService.getTransation().PaletteEditor }}
  </button>
</mat-menu>
<mat-menu #menuHelp="matMenu" hasBackdrop="false" (closed)="onMenuClosed()" (opened)="onMenuOpened()">
  <!-- Welcome tour menu item removed - replaced with new onboarding system -->
  <button mat-menu-item (click)="videoTutorial()">
    <mat-icon>movie</mat-icon>
    {{ httpService.getTransation().VideoTutorial }}
  </button>
</mat-menu>
